import http from '@/communication/AuthConnection'

export default ({ _id, idx }) => {
  return http.delete(`/v1/user/${_id}`)
    .then(pData => idx)
}



// WEBPACK FOOTER //
// ./src/brain/record/user/RemoveUser.js